import React, { Component } from 'react'
import { Alert, Button, Modal, Select, Spin } from 'antd'
import {
    MANUAL_SKU_TEXT,
    manualSkuConfirmText,
    manualSkuOptionLabel,
    manualSkuPickerGroups,
    skuCountText,
    skuHistoryHintText
} from '../utils'

// Manual SKU V1: the operator picks ONE code for the row. Presentational only -- the queue owns
// the state, the request and the reload.
//
// HUMAN DECISION ONLY. The picker starts EMPTY on every open, whatever the history says; the
// history hint can fill it only through its own explicit "בחר" click; and choosing a code never
// submits -- "המשך" moves to a second confirmation, and only that confirmation POSTs.
//
// PRIVACY: the evidence is skus, dates and counts; no customer, product-string or payment value
// reaches here.
const SECTION = { marginBottom: 6, fontWeight: 500 }
const MUTED = { color: '#8c8c8c' }

export default class AssignSkuModal extends Component<any, any> {
    side = (label, entry) => (
        <div>
            {label}{' '}
            {entry ? (
                <span dir="ltr">
                    {entry.sku} · {entry.date}
                </span>
            ) : (
                <span style={MUTED}>{MANUAL_SKU_TEXT.none}</span>
            )}
        </div>
    )

    evidenceBlock = () => {
        const { evidence, submitting, onPickHint } = this.props
        const history = (evidence && evidence.history) || []
        const hint = skuHistoryHintText(evidence)
        return (
            <div>
                <div style={SECTION}>היסטוריה ליד העסקה</div>
                {this.side('מק״ט קודם:', evidence.previous)}
                {this.side('מק״ט הבא:', evidence.next)}

                <div style={Object.assign({ marginTop: 12 }, SECTION)}>היסטוריית מק״טים</div>
                {history.length === 0 ? (
                    <span style={MUTED}>{MANUAL_SKU_TEXT.noHistory}</span>
                ) : (
                    history.map(entry => (
                        <div key={entry.sku}>
                            <span dir="ltr">{entry.sku}</span> — {skuCountText(entry.count)}
                        </div>
                    ))
                )}

                {hint ? (
                    <Alert
                        style={{ marginTop: 12 }}
                        type="info"
                        message={hint}
                        description={
                            <Button
                                size="small"
                                disabled={submitting}
                                onClick={() => onPickHint(evidence.history_hint_sku)}
                            >
                                {`בחר ${evidence.history_hint_sku}`}
                            </Button>
                        }
                    />
                ) : null}
            </div>
        )
    }

    picker = () => {
        const { evidence, selected, submitting, onSelect } = this.props
        const groups = manualSkuPickerGroups(evidence)
        const option = entry => (
            <Select.Option key={entry.sku} value={entry.sku}>
                {manualSkuOptionLabel(entry)}
            </Select.Option>
        )
        return (
            <div style={{ marginTop: 12 }}>
                <div style={SECTION}>בחירת מק״ט</div>
                <Select
                    showSearch
                    allowClear
                    // undefined -> the placeholder: nothing is selected until the operator chooses.
                    value={selected || undefined}
                    placeholder="בחר מק״ט"
                    optionFilterProp="children"
                    disabled={submitting}
                    onChange={value => onSelect(value || null)}
                    style={{ width: '100%' }}
                >
                    {groups.fromHistory.length ? (
                        <Select.OptGroup key="history" label="מההיסטוריה של הלקוח">
                            {groups.fromHistory.map(option)}
                        </Select.OptGroup>
                    ) : null}
                    <Select.OptGroup key="all" label="כל המק״טים">
                        {groups.rest.map(option)}
                    </Select.OptGroup>
                </Select>
            </div>
        )
    }

    footerButton = (key, label, onClick, disabled, primary, loading = false) => (
        <Button
            key={key}
            type={primary ? 'primary' : 'default'}
            onClick={onClick}
            disabled={disabled}
            loading={loading}
        >
            {label}
        </Button>
    )

    render() {
        const {
            row,
            loading,
            evidence,
            selected,
            confirming,
            submitting,
            onCancel,
            onRequestConfirm,
            onBack,
            onConfirm
        } = this.props

        // Step one picks and continues; step two is the ONLY control that submits.
        const footer = confirming
            ? [
                  this.footerButton('back', 'חזרה', onBack, submitting, false),
                  this.footerButton('confirm', 'שייך', onConfirm, !selected || submitting, true, submitting)
              ]
            : [
                  this.footerButton('cancel', 'ביטול', onCancel, submitting, false),
                  this.footerButton('next', 'המשך', onRequestConfirm, loading || !evidence || !selected, true)
              ]

        return (
            <Modal
                visible={!!row}
                title="שייך מק״ט"
                onCancel={submitting ? undefined : onCancel}
                maskClosable={!submitting}
                closable={!submitting}
                footer={footer}
            >
                {loading || !evidence ? (
                    <Spin />
                ) : confirming ? (
                    <div dir="rtl">{manualSkuConfirmText(selected)}</div>
                ) : (
                    <div>
                        {this.evidenceBlock()}
                        {this.picker()}
                    </div>
                )}
            </Modal>
        )
    }
}
